import React from 'react';
import { render } from 'react-dom';
import Calendar from '~react/components/Calendar';
import { getJsonDataFromDataAttribute } from '~utils/json';
import { FilterCell } from '~react/components/Calendar/components/Filter';
import { ActionData } from '~react/components/Calendar/components/Actions';

document.addEventListener('DOMContentLoaded', () => {
    const calendarApp: HTMLElement | null = document.getElementById('calendarApp');

    if (null === calendarApp) {
        return;
    }
    // TODO add type check on received config
    render(
        <Calendar
            config={
                getJsonDataFromDataAttribute(calendarApp.getAttribute('data-calendar')) as {
                    apiUrl: string;
                    filters: FilterCell[];
                    actions?: ActionData[];
                    weekends?: boolean;
                }
            }
        />,
        calendarApp,
    );
});
